import { jsx as _jsx } from "react/jsx-runtime";
import { Body1 } from "@fluentui/react-components";
import { PropertyLine } from "./propertyLine";
/**
 * Wraps text in a property line
 * @param props - PropertyLineProps and TextProps
 * @returns property-line wrapped text
 */
export const TextPropertyLine = (props) => {
    TextPropertyLine.displayName = "TextPropertyLine";
    const { value, title } = props;
    return (_jsx(PropertyLine, { ...props, children: _jsx(Body1, { title: title, children: value ?? "" }) }));
};
//# sourceMappingURL=textPropertyLine.js.map